import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import i18n from './libs/i18n'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ui)

// Mount only once the FIRST navigation — auth guard included — has resolved (vue-spec
// `bootstrap.md` step 20), so the signed-in chrome never flashes before a redirect.
router.isReady().then(() => app.mount('#app'))
